import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { OidcAuthService } from './oidc-auth.service';
import { GlobalStartupService } from '../../common/services/global-startup-service';
import { take, combineLatest } from 'rxjs';
import { UserSettingsService } from '@user-settings/services/user-settings.service';
import { of, Observable } from 'rxjs';
import { mapTo } from 'rxjs';
import { UserPreferencesService } from '@feature/user-preferences/services/user-preferences.service';

@Injectable()
export class OidcAuthRouteGuardService  {

  constructor(
    private readonly userSettingsService: UserSettingsService, 
    private readonly authService: OidcAuthService,
    private readonly globalStartup: GlobalStartupService,
    private readonly userPreferenceService: UserPreferencesService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    if (this.authService.isLoggedIn) {
      this.globalStartup.initSystemSettings();      
      return combineLatest([this.userSettingsService.getUserSettings(), this.userPreferenceService.getUserPreferences()]).pipe(mapTo(true));
    }
    this.authService.startAuthentication({ url: state.url }).pipe(take(1)).subscribe(u => console.log('startAuthentication'));
    return of(false);
  }

}
